export default __webpack_public_path__ + "static/media/PAR.36f8e510.svg";